"use client";
import { Button } from "@/components/ui/button";
import { IconCopy } from "@tabler/icons-react";
import React from "react";
import ReactGPicker from "react-gcolor-picker";
import { toast } from "sonner";
interface Props {
    value: string;
    onChange: (value: string) => void;
    gradient?: boolean;
    dev?: boolean;
    userColors?: string[];
}
export function ColorPicker({
    value,
    onChange,
    gradient,
    dev,
    userColors,
}: Props) {
    const gradients = [
        // 1
        "linear-gradient(45deg, rgb(255, 0, 0) 0.00%,rgb(0, 0, 0) 2.00%,rgb(255, 227, 0) 4.00%,rgb(0, 0, 0) 6.00%,rgb(55, 255, 0) 8.00%,rgb(0, 0, 0) 10.00%,rgb(0, 255, 209) 12.00%,rgb(0, 0, 0) 14.00%,rgb(21, 0, 255) 16.00%,rgb(0, 0, 0) 18.00%,rgb(232, 0, 255) 20.00%,rgb(0, 0, 0) 22.00%,rgb(255, 0, 0) 24.00%,rgb(0, 0, 0) 26.00%,rgb(100, 100, 100) 50.00%,rgb(0, 0, 0) 74.00%,rgb(255, 0, 0) 76.00%,rgb(0, 0, 0) 78.00%,rgb(241, 255, 0) 80.00%,rgb(0, 0, 0) 82.00%,rgb(5, 255, 0) 84.00%,rgb(0, 0, 0) 86.00%,rgb(0, 255, 239) 88.00%,rgb(0, 0, 0) 90.00%,rgb(0, 19, 255) 92.00%,rgb(0, 0, 0) 94.00%,rgb(246, 0, 255) 96.00%,rgb(0, 0, 0) 98.00%,rgb(255, 0, 0) 100.00%)",
        // 2
        "linear-gradient(135deg, rgb(172, 202, 189) 0.00%,rgb(172, 202, 189) 0.00%,rgb(172, 202, 189) 0.00%,rgb(0, 0, 0) 4.00%,rgb(255, 0, 0) 4.00%,rgb(255, 0, 0) 6.00%,rgb(255, 136, 0) 6.00%,rgb(255, 136, 0) 8.00%,rgb(248, 255, 0) 8.00%,rgb(248, 255, 0) 10.00%,rgb(45, 189, 0) 10.00%,rgb(45, 189, 0) 12.00%,rgb(0, 15, 189) 12.00%,rgb(0, 15, 189) 14.00%,rgb(155, 0, 189) 14.00%,rgb(155, 0, 189) 16.00%,rgb(0, 0, 0) 16.00%,rgb(96, 89, 102) 17.00%,rgb(76, 136, 134) 29.00%,rgb(117, 120, 202) 39.00%,rgb(169, 105, 219) 51.00%,rgb(181, 103, 183) 62.00%,rgb(153, 88, 208) 72.00%,rgb(174, 120, 221) 86.00%,rgb(206, 123, 157) 100.00%)",
        // 3
        "linear-gradient(135deg, rgb(255, 54, 54) 5.00%,rgb(215, 225, 61) 16.00%,rgb(215, 82, 244) 31.00%,rgb(0, 255, 23) 48.00%,rgb(255, 148, 0) 66.00%,rgb(95, 0, 255) 80.00%,rgb(54, 216, 255) 93.00%)",
        // 4
        "radial-gradient(circle at left, rgb(107, 108, 107) 0.00%,rgb(0, 0, 0) 50.00%,rgb(0, 0, 0) 74.00%,rgb(255, 0, 0) 77.00%,rgb(0, 0, 0) 81.00%,rgb(0, 255, 13) 85.00%,rgb(0, 0, 0) 88.00%,rgb(31, 0, 255) 92.00%,rgb(0, 0, 0) 95.00%)",
        // 5
        "linear-gradient(45deg, rgb(57, 57, 57) 8.00%,rgb(0, 0, 0) 16.00%,rgb(255, 255, 255) 16.00%,rgb(255, 0, 0) 17.00%,rgb(0, 0, 0) 24.00%,rgb(6, 6, 6) 25.00%,rgb(0, 0, 0) 25.00%,rgb(0, 0, 0) 25.00%,rgb(255, 255, 255) 25.00%,rgb(21, 0, 255) 26.00%,rgb(0, 0, 0) 32.00%,rgb(0, 0, 0) 32.00%,rgb(6, 6, 6) 32.00%,rgb(0, 0, 0) 31.00%,rgb(60, 68, 70) 77.00%,rgb(0, 0, 0) 97.00%)",
        // 6
        "linear-gradient(180deg, rgb(246, 70, 70) 0.00%,rgb(255, 0, 168) 12.00%,rgb(174, 0, 255) 27.00%,rgb(199, 0, 255) 40.00%,rgb(187, 61, 251) 51.00%,rgb(199, 0, 255) 62.00%,rgb(174, 0, 255) 75.00%,rgb(248, 0, 255) 90.00%,rgb(246, 70, 70) 100.00%)",
        // 7
        "linear-gradient(135deg, rgb(0, 0, 0) 0.00%,rgb(255, 0, 0) 4.00%,rgb(0, 0, 0) 8.00%,rgb(149, 0, 0) 13.00%,rgb(0, 0, 0) 18.00%,rgb(91, 0, 0) 23.00%,rgb(0, 0, 0) 28.00%,rgb(51, 0, 0) 40.00%,rgb(51, 0, 0) 55.00%,rgb(0, 0, 0) 71.00%,rgb(83, 1, 1) 76.00%,rgb(0, 0, 0) 80.00%,rgb(166, 1, 1) 85.00%,rgb(0, 0, 0) 90.00%,rgb(255, 0, 0) 95.00%,rgb(0, 0, 0) 99.00%)",
        // 8
        "linear-gradient(45deg, rgb(76, 108, 107) 3.00%,rgb(88, 119, 119) 13.00%,rgb(143, 153, 153) 21.00%,rgb(118, 140, 140) 30.00%,rgb(112, 153, 153) 62.00%,rgb(143, 170, 170) 73.00%,rgb(147, 191, 191) 83.00%,rgb(251, 251, 251) 100.00%)",
        // 9
        "linear-gradient(0deg, rgb(0, 0, 0) 0.00%,rgb(255, 255, 255) 5.00%,rgb(184, 199, 212) 26.00%,rgb(255, 255, 255) 50.00%,rgb(146, 176, 176) 78.00%,rgb(116, 125, 125) 96.00%,rgb(255, 255, 255) 100.00%)",
        // 10
        "linear-gradient(0deg, rgb(0, 0, 0) 0.00%,rgb(62, 61, 61) 7.00%,rgb(27, 32, 36) 25.00%,rgb(0, 0, 0) 50.00%,rgb(23, 28, 28) 78.00%,rgb(45, 47, 47) 95.00%,rgb(115, 113, 113) 99.00%)",
        // 11
        // "linear-gradient(45deg, rgb(0, 0, 0) 0.00%,rgb(116, 125, 125) 100.00%)",
        // 12
        // "linear-gradient(315deg, #272727 0%, #1F1F1F 100%)",
    ];

    // Remove duplicates: if a color is in userColors, don't show it in the hardcoded list
    const userColorsSet = new Set(
        (userColors || []).map((c) => c?.toLowerCase?.() ?? c)
    );
    const hardcodedColors = [
        "#cd514b",
        "#A8A82A",
        "#924bcd",
        "#4bcd4b",
        "#101010",
        "#141414",
        "#141414",
        "#252525",
        "#fafafa",
    ].filter((color) => !userColorsSet.has(color.toLowerCase()));
    const defaultColors = [
        "transparent",
        ...(userColors || []),
        ...hardcodedColors,
        ...gradients,
    ];
    return (
        <>
            <ReactGPicker
                value={value}
                onChange={(value) => {
                    const isGradient =
                        value?.includes("radial-gradient") ||
                        value?.includes("linear-gradient");
                    const values = value.match(/\d+/g);
                    if (!isGradient && values) {
                        const r = parseInt(values[0]);
                        const g = parseInt(values[1]);
                        const b = parseInt(values[2]);
                        const a = parseInt(values[3]);
                        if (
                            (r !== 0 && a === 0) ||
                            (g !== 0 && a === 0) ||
                            (b !== 0 && a === 0)
                        ) {
                            value = value = `rgb(${r}, ${g}, ${b})`;
                        }
                    }
                    onChange(value);
                }}
                showAlpha={false}
                gradient={gradient}
                defaultColors={defaultColors}
                format={"rgb"}
            />
            {dev && (
                <div className="flex items-center gap-3">
                    <Button
                        onClick={async () => {
                            try {
                                toast.success("Color code copied to clipboard");
                                await navigator.clipboard.writeText(value);
                            } catch (err) {
                                console.error("Failed to copy text: ", err);
                                toast.error("Failed to copy to clipboard");
                            }
                        }}
                    >
                        <IconCopy />
                    </Button>
                </div>
            )}
        </>
    );
}
